
import React, { useState } from 'react';
import SectionTitleBar from '../components/titlebar';
import { BaseReact } from '../../base.model';

import './Dashboard.scss';
import { ProfileQL } from '../../models/Profile';
import { useQuery } from '@apollo/react-hooks';
import { graphqlSchema } from '../../services/graphql.schema';
import { ToBillArguments, ToBillEvent } from '../../models/Factura';

import { formatCurrencyStyled } from '../visuals/currency.formatted';
import { clearGqlTypename } from '../../utils/formatting';
import { Cotizacion } from '../../models/Cotizaciones';
import { setSortOrder } from '../../utils/cotizaciones.formatting';
import Loading from '../Animations/loadScreen';

import unifiedMoment from '../../services/unifiedMoment';
import CotizacionesStatusLabel from '../Cotizaciones/Cotizaciones.status';
import DashboardBillEventList from './Dashboard.billEventList';
import DashboardNotifications from './Dashboard.notifications';
import DashboardSummary from './Dashboard.summary';

const moment = unifiedMoment;

interface DashboardProps extends BaseReact {
    currentUser: ProfileQL;
}

function Dashboard({ history, location, currentUser }: DashboardProps) {
    // Cotizaciones
    const [cotizaciones, setCotizaciones] = useState<Cotizacion[]>([]);
    const [cotizacionLoaded, setCotizacionLoaded] = useState(false);

    useQuery(graphqlSchema.FISCALPOP.COTIZACION.fetchOpenCotizaciones, {
        onCompleted: ({ fetchOpenCotizaciones }: { fetchOpenCotizaciones: Cotizacion[] }) => {
            setCotizaciones(fetchOpenCotizaciones.filter(c => !(c.wasCancelled || c.paid)).sort((a, b) => (setSortOrder(b) - setSortOrder(a))));
            setCotizacionLoaded(true);
            console.log(`fetchCotizaciones: `, fetchOpenCotizaciones);
        },
        onError: (e) => {
            console.error('Error fetching cotizaciones: ', e.graphQLErrors[0]);
        },
        fetchPolicy: 'cache-and-network'
    })

    const goToEmitBillEvent = (billEvent: ToBillEvent, parentArgument: ToBillArguments<ToBillEvent>) => {
        history.push({
            pathname: '/facturacion/facturar/preview/billevent',
            state: { billArgument: parentArgument, billEvents: [billEvent] }
        })
    }

    const goToEmitPago = (billEvent: ToBillEvent, parentArgument: ToBillArguments<ToBillEvent>) => {
        history.push({
            pathname: '/facturacion/setup/pagos',
            state: { billArgument: clearGqlTypename(parentArgument), paymentEvents: [clearGqlTypename(billEvent)] }
        })
    }

    return (
        <div id="Dashboard">
            <SectionTitleBar currentUser={currentUser} title="Resumen de Facturación" />
            <div className="dashboardContent">
                <div className="summaryActivity">
                    <DashboardSummary currentUser={currentUser} />
                    <DashboardNotifications history={history} />
                </div>

                <div className={`tableDashboard  _widthSide`}>
                    <div className="_bills">
                        <h4>Facturas o complementos de pago pendientes</h4>
                        <DashboardBillEventList
                            onEmitBillEvent={goToEmitBillEvent}
                            onEmitPago={goToEmitPago}
                        />
                    </div>
                    <div className="_quotes">
                        <h4>Cotizaciones en proceso</h4>
                        <div className="card table">
                            <div className="cardTitle">
                                <div className="header cotizacionPreview">
                                    <p>Cliente</p>
                                    <p className="monto">Monto</p>
                                </div>
                            </div>
                            <div className="cardBody">
                                {
                                    !cotizaciones.length ?
                                        (
                                            cotizacionLoaded ?

                                                <div className="noPreviews">
                                                    <p>
                                                        No hay Cotizaciones pendientes revisar
                                                    </p>
                                                </div>
                                                :
                                                <Loading svgHeight={'40px'} display={true} relativePos={true} />
                                        )
                                        :
                                        ''
                                }
                                {
                                    cotizaciones.map((cot, i) => {
                                        return (
                                            <div className="cotizacionPreview" key={i}>
                                                <div className="_receptor">
                                                    <p className="_name">{cot.name}</p>
                                                    <p className="date"> {moment(cot.createdAt).format('DD / MMM / YYYY')}</p>
                                                </div>
                                                <div className="_monto">
                                                    <p className="text2">{formatCurrencyStyled(cot.total)}</p>
                                                    <CotizacionesStatusLabel cotizacion={cot} />
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Dashboard;
